import { Plugin } from "grapesjs";
import loadComponents from "./components";
import loadBlocks from "./block";
import {
  PluginOptions,
  RequiredPluginOptions,
} from "../../../../../types/types";

const plugin: Plugin<PluginOptions> = (editor, opts = {}) => {
  const options: RequiredPluginOptions = {
    id: "filterCard",
    label: "Filter Card",
    block: {},
    style: "",
    styleAdditional: "",
    classPrefix: "filterCard",
    ...opts,
  };

  loadBlocks(editor, options);
  loadComponents(editor, options);
};

export default plugin;
